import { VisualizerStyle } from "../components/AudioVisualizer";
import type { CompanyBadgeStyle } from "../components/CompanyBadge";

import { BoldCreatorConfig } from "./BoldCreator";
import { MinimalGlassConfig } from "./MinimalGlass";
import { RetroTerminalConfig } from "./RetroTerminal";
import { EditorialCreamConfig } from "./EditorialCream";
import { KineticFlashConfig } from "./KineticFlash";
import { SpatialThreeConfig } from "./SpatialThree";
import { AuroraNatureConfig } from "./AuroraNature";
import { UrbanStreetConfig } from "./UrbanStreet";
import { LuxuryGoldConfig } from "./LuxuryGold";
import { PastelPopConfig } from "./PastelPop";
import { CorporateProConfig } from "./CorporatePro";
import { Cyberpunk2099Config } from "./Cyberpunk2099";
import { OceanDepthsConfig } from "./OceanDepths";
import { VintageFilmConfig } from "./VintageFilm";
import { SportsEnergyConfig } from "./SportsEnergy";
import { ZenMinimalConfig } from "./ZenMinimal";
import { EtherealPrismConfig } from "./EtherealPrism";
import { InkPorcelainConfig } from "./InkPorcelain";
import { NeobrutalistConfig } from "./Neobrutalist";
import { MinimalImpactConfig } from "./MinimalImpact";
import { GraphicNewsConfig } from "./GraphicNews";
import { VectorMotionConfig } from "./VectorMotion";
import { SvgHeroConfig } from "./SvgHero";
import { SolarFlareConfig } from "./SolarFlare";
import { KineticTypeConfig } from "./KineticType";
import { VelocityTechConfig } from "./VelocityTech";
import { GeometricLiquidConfig } from "./GeometricLiquid";
import { CinematicEpicConfig } from "./CinematicEpic";
import { ReactbitsGlowConfig } from "./ReactbitsGlow";
import { GridMotionConfig } from "./GridMotion";


type TemplateComponentProps = Record<string, unknown>;

export type TemplateName =
  | "bold-creator"
  | "minimal-glass"
  | "retro-terminal"
  | "editorial-cream"
  | "kinetic-flash"
  | "spatial-three"
  | "aurora-nature"
  | "urban-street"
  | "luxury-gold"
  | "pastel-pop"
  | "corporate-pro"
  | "cyberpunk-2099"
  | "ocean-depths"
  | "vintage-film"
  | "sports-energy"
  | "zen-minimal"
  | "ethereal-prism"
  | "ink-porcelain"
  | "vector-motion"
  | "neobrutalist"
  | "minimal-impact"
  | "graphic-news"
  | "svg-hero"
  | "solar-flare"
  | "kinetic-type"
  | "velocity-tech"
  | "geometric-liquid"
  | "cinematic-epic"
  | "reactbits-glow"
  | "grid-motion";

export interface TemplateRegistryItem {
  compositionId: string;
  templateName: TemplateName;
  BackgroundComponent: unknown;
  CaptionsComponent: unknown;
  TemplateComponent: unknown;
  IntroComponent: unknown;
  OutroComponent: unknown;
  dividerGradient: string;
  watermarkTextColor?: string;
  instagramIconColor: string;
  progressBarStyle: { background: string; boxShadow: string; display?: string };
  footerTextColor?: string;
  footerFontFamily?: string;
  defaultProps?: TemplateComponentProps;
  visualizerStyle?: VisualizerStyle;
  hideVisualizer?: boolean;
  hideWatermark?: boolean;
  /** Which CompanyBadge visual preset to use when rendering brand icons */
  companyBadgeStyle?: CompanyBadgeStyle;
  /** Primary accent color for CompanyBadge (hex with #) */
  companyBadgeColor?: string;
}

export const templateRegistry: TemplateRegistryItem[] = [
  BoldCreatorConfig,
  MinimalGlassConfig,
  RetroTerminalConfig,
  EditorialCreamConfig,
  KineticFlashConfig,
  SpatialThreeConfig,
  AuroraNatureConfig,
  UrbanStreetConfig,
  LuxuryGoldConfig,
  PastelPopConfig,
  CorporateProConfig,
  Cyberpunk2099Config,
  OceanDepthsConfig,
  VintageFilmConfig,
  SportsEnergyConfig,
  ZenMinimalConfig,
  EtherealPrismConfig,
  InkPorcelainConfig,
  NeobrutalistConfig,
  MinimalImpactConfig,
  GraphicNewsConfig,
  VectorMotionConfig,
  SvgHeroConfig,
  SolarFlareConfig,
  KineticTypeConfig,
  VelocityTechConfig,
  GeometricLiquidConfig,
  CinematicEpicConfig,
  ReactbitsGlowConfig,
  GridMotionConfig,
];

export const fallbackTemplate = ZenMinimalConfig;

export const templateRegistryMap = Object.fromEntries(
  templateRegistry.map((item) => [item.templateName, item]),
) as Record<TemplateName, TemplateRegistryItem>;

export const compositionIdToTemplateName = Object.fromEntries(
  templateRegistry.map((item) => [item.compositionId, item.templateName]),
) as Record<string, TemplateName>;

export function resolveTemplate(input?: string | null) {
  if (!input) {
    return templateRegistryMap["zen-minimal"];
  }

  const byName = templateRegistry.find((item) => item.templateName === input);
  if (byName) {
    return byName;
  }

  const byCompositionId = templateRegistry.find((item) => item.compositionId === input);
  return byCompositionId ?? templateRegistryMap["zen-minimal"];
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
